import type { PlcDiagnosticCode, PlcManufacturerCodeLibrary } from "./types";
import { siemensCodeLibrary } from "./siemens";
import { rockwellCodeLibrary } from "./rockwell";
import { mitsubishiCodeLibrary } from "./mitsubishi";
import { schneiderCodeLibrary } from "./schneider";
import { omronCodeLibrary } from "./omron";
import { abbCodeLibrary } from "./abb";
import { deltaCodeLibrary } from "./delta";
import { beckhoffCodeLibrary } from "./beckhoff";
import { wagoCodeLibrary } from "./wago";
import { phoenix_contactCodeLibrary } from "./phoenix-contact";
import { unitronicsCodeLibrary } from "./unitronics";
import { keyenceCodeLibrary } from "./keyence";
import { panasonicCodeLibrary } from "./panasonic";
import { ls_electricCodeLibrary } from "./ls-electric";
import { automationdirectCodeLibrary } from "./automationdirect";
import { br_automationCodeLibrary } from "./br-automation";
import { bosch_rexrothCodeLibrary } from "./bosch-rexroth";
import { honeywellCodeLibrary } from "./honeywell";
import { emersonCodeLibrary } from "./emerson";

export const plcCodeLibraries: PlcManufacturerCodeLibrary[] = [
  siemensCodeLibrary,
  rockwellCodeLibrary,
  mitsubishiCodeLibrary,
  schneiderCodeLibrary,
  omronCodeLibrary,
  abbCodeLibrary,
  deltaCodeLibrary,
  beckhoffCodeLibrary,
  wagoCodeLibrary,
  phoenix_contactCodeLibrary,
  unitronicsCodeLibrary,
  keyenceCodeLibrary,
  panasonicCodeLibrary,
  ls_electricCodeLibrary,
  automationdirectCodeLibrary,
  br_automationCodeLibrary,
  bosch_rexrothCodeLibrary,
  honeywellCodeLibrary,
  emersonCodeLibrary,
];

export const plcDiagnosticCodes: PlcDiagnosticCode[] =
  plcCodeLibraries.flatMap((library) => library.codes);

export function getPlcCodesByManufacturer(manufacturerId: string) {
  return plcDiagnosticCodes.filter(
    (item) => item.manufacturer_id === manufacturerId,
  );
}

export function getPlcCodesBySeries(
  manufacturerId: string,
  seriesId: string,
) {
  return plcDiagnosticCodes.filter(
    (item) =>
      item.manufacturer_id === manufacturerId &&
      item.series_id === seriesId,
  );
}

export function getPlcCodesByModel(
  manufacturerId: string,
  seriesId: string,
  model: string,
) {
  return plcDiagnosticCodes.filter(
    (item) =>
      item.manufacturer_id === manufacturerId &&
      item.series_id === seriesId &&
      item.model === model,
  );
}

export function findPlcCode(
  manufacturerId: string,
  seriesId: string,
  code: string,
) {
  const target = code.trim().toLowerCase();

  return plcDiagnosticCodes.find(
    (item) =>
      item.manufacturer_id === manufacturerId &&
      item.series_id === seriesId &&
      item.code.trim().toLowerCase() === target,
  );
}
